import React from 'react';

import t from '../../../labels/labelling-utils';
import { MatchStatusType } from '../../../typings/match';
import { ReportStatus } from '../../../typings/match-reports';
import { IReferee } from '../../../typings/player';
import { isPostponed } from '../../../utils/match-status';
import { isPublished } from '../../../utils/report-status';
import { makeClassNames } from '../../../utils/styles';
import Callout from '../../atoms/callout/callout';
import ReportTabsPanel, { IReportTabsPanel } from '../../molecules/report-tabs-panel/report-tabs-panel';
import { ITeam } from '../../molecules/team/team';
import TeamsTabs from '../../molecules/teams-tabs/teams-tabs';

import './report-tabs.scss';

export interface IReportTeam extends ITeam {}

export interface IReportTabs extends IReportTabsPanel {
  away: IReportTeam;
  home: IReportTeam;
  idAway: string;
  idHome: string;
  referees?: IReferee[];
  reportStatus?: ReportStatus;
  status?: MatchStatusType;
}

const classNames = () =>
  makeClassNames({
    reportTabs: 'report-tabs',
    panels: 'report-tabs__panels',
  });

const ReportTabs = ({ away, home, idAway, idHome, referees, reportStatus, status }: IReportTabs) => {
  const cn = classNames();

  let panel = null;
  if (reportStatus && isPublished(reportStatus)) {
    panel = <ReportTabsPanel home={home} away={away} referees={referees} status={status} />;
  } else if (isPostponed(status!)) {
    panel = <Callout>{t('report.tabs.postponed')}</Callout>;
  } else {
    panel = <Callout>{t('report.tabs.unavailable')}</Callout>;
  }

  return (
    <div className={cn.reportTabs}>
      <TeamsTabs idHome={idHome} idAway={idAway} home={home} away={away} />
      <div className={cn.panels} data-panels>
        {panel}
      </div>
    </div>
  );
};

export default ReportTabs;
